<template>
  <div class="oa-page">
    <div v-if="loading" class="loading-spinner"></div>
    <Loading class="iv-loading" v-if="!loading"></Loading>
  </div>
</template>

<script>
import Loading from "@/components/loading"
export default {
  name: 'oaLogin',
  data() {
    return {
      loading: false
    }
  },
  components: {
    Loading
  },
  created() {
    this.getLogin()
  },
  methods: {
    getLogin() {
      this.$ajax({
        url: `api-sso/oa/login?ticket=${this.$route.query.ticket}`,
        method: 'GET',
      }).then((res) => {
        this.loading = true
        if (res.data.code === 0) {
          sessionStorage.setItem('token', res.data.data.access_token);
          this.$router.push({
            name: 'homePage'
          });
        } else if(res.data.code === 401) {
          this.$router.push({
            name: '401'
          });
        }
      }).catch(err => {
        this.loading = false
        //err.data.code
      })
    }
  }
}
</script>
<style lang="scss">
.iv-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 9999;
}
</style>

